// extracted by mini-css-extract-plugin
export default {"bounce":"S_d1","loading":"S_d2","logo-mark-bounce-right":"S_d3","logo-mark-bounce-left":"S_d4"};